// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoryTree_CategoryTree__OCx5M {
  position: relative;
}
.CategoryTree_CategoryTree__OCx5M.CategoryTree_CategoryTree__OCx5M {
  margin-top: 8px;
}
.CategoryTree_CategoryTree__OCx5M h3 {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--brand);
  padding: 6px 12px;
  border: 1px solid var(--border);
  background-color: var(--white);
  width: fit-content;
  border-radius: 500px;
  position: relative;
  z-index: 2;
}
.CategoryTree_CategoryTree__OCx5M .CategoryTree_CategoryTreeItem__aMxY6 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 40px;
  padding-top: 8px;
  position: relative;
}
.CategoryTree_CategoryTree__OCx5M .CategoryTree_CategoryTreeItem__aMxY6::before {
  content: "";
  position: absolute;
  top: 0;
  left: 20px;
  display: block;
  width: 100%;
  border-left: 1px solid var(--border);
  z-index: 0;
}
.CategoryTree_CategoryTree__OCx5M .CategoryTree_CategoryTreeItem__aMxY6 li {
  position: relative;
  z-index: 1;
  width: fit-content;
}
.CategoryTree_CategoryTree__OCx5M .CategoryTree_CategoryTreeItem__aMxY6 li span {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  padding: 6px 12px;
  border: 1px solid var(--border);
  border-radius: 500px;
  background-color: var(--white);
  position: relative;
  z-index: 1;
  display: block;
}
.CategoryTree_CategoryTree__OCx5M .CategoryTree_CategoryTreeItem__aMxY6 li::before {
  content: "";
  position: absolute;
  bottom: 50%;
  left: -20px;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 0 0 0 12px;
  border: 1px solid var(--border);
  border-top: 0;
  border-right: 0;
  z-index: 0;
}
.CategoryTree_CategoryTree__OCx5M.CategoryTree_CategoryTree__OCx5M {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/CategoryTree/CategoryTree.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;AACC;EACC,eAAA;AACF;AACC;EACC,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AACF;AAEC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;AAEE;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;AAAH;AAGE;EACC,kBAAA;EACA,UAAA;EACA,kBAAA;AADH;AAGG;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;EACA,+BAAA;EACA,oBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AADJ;AAIG;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;AAFJ;AAMC;EACC,gBAAA;AAJF","sourcesContent":[".CategoryTree {\r\n\tposition: relative;\r\n\r\n\t&.CategoryTree {\r\n\t\tmargin-top: 8px;\r\n\t}\r\n\th3 {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 500;\r\n\t\tcolor: var(--brand);\r\n\t\tpadding: 6px 12px;\r\n\t\tborder: 1px solid var(--border);\r\n\t\tbackground-color: var(--white);\r\n\t\twidth: fit-content;\r\n\t\tborder-radius: 500px;\r\n\t\tposition: relative;\r\n\t\tz-index: 2;\r\n\t}\r\n\r\n\t.CategoryTreeItem {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 8px;\r\n\t\tpadding-left: 40px;\r\n\t\tpadding-top: 8px;\r\n\t\tposition: relative;\r\n\r\n\t\t&::before {\r\n\t\t\tcontent: '';\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: 20px;\r\n\t\t\tdisplay: block;\r\n\t\t\twidth: 100%;\r\n\t\t\tborder-left: 1px solid var(--border);\r\n\t\t\tz-index: 0;\r\n\t\t}\r\n\r\n\t\tli {\r\n\t\t\tposition: relative;\r\n\t\t\tz-index: 1;\r\n\t\t\twidth: fit-content;\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tpadding: 6px 12px;\r\n\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t\tborder-radius: 500px;\r\n\t\t\t\tbackground-color: var(--white);\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tz-index: 1;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\t&::before {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tbottom: 50%;\r\n\t\t\t\tleft: -20px;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tborder-radius: 0 0 0 12px;\r\n\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t\tborder-top: 0;\r\n\t\t\t\tborder-right: 0;\r\n\t\t\t\tz-index: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t&.CategoryTree {\r\n\t\tmargin-top: 10px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CategoryTree": `CategoryTree_CategoryTree__OCx5M`,
	"CategoryTreeItem": `CategoryTree_CategoryTreeItem__aMxY6`
};
export default ___CSS_LOADER_EXPORT___;
